module.exports = __webpack_public_path__ + "img/K75-HQ.75acc1ae.png";